module.exports = __webpack_public_path__ + "img/icon-xsteacher-logo.aeb46b5b.png";